<template>
  <div
    class="cover"
    :class="{ 'cover--started': started }"
    @click="start"
  ></div>
</template>

<script>
export default {
  data () {
    return {
      started: false
    }
  },

  methods: {
    start () {
      if (this.started) return
      this.started = true
      this.$emit('start')
    }
  }
}
</script>

<style lang="stylus">
.cover
  background url(/images/cover.jpg) no-repeat center center
  background-size auto 100%
  box-sizing border-box
  position: relative
  width 100%
  height 100%

  &:not(&--started)
    cursor pointer

  &::before
    content ''
    background url(/images/play-cover.svg) no-repeat center center
    background-size contain
    width 150px
    height 150px
    left 50%
    top 50%
    opacity 0.8
    position absolute
    transform translate(-50%, -50%) scale(0.9)
    transition .3s

  &:not(&--started):hover::before
    opacity 1
    transform translate(-50%, -50%) scale(1)

  &--started::before
    opacity 0
    transform translate(-50%, -50%) scale(0.95)
    transition .6s

  &:active::before, &:active:hover::before
    transform translate(-50%, -50%) scale(0.95)
    transition .1s
</style>
